const TinCan = require('tincanjs');
class XAPIService {
  private xapi: any;
  private activityId: any;
  constructor(activityId: string) {
    this.initializeXAPI(activityId);
  }

  public extractEmail(input: string): string | null {
    const emailRegex = /[\w.-]+@[\w.-]+\.[A-Za-z]{2,}/;
    const match = input.match(emailRegex);
    return match ? match[0] : null;
  }

  public initializeXAPI(activityId: string) {
    this.xapi = new TinCan({
      url: window.location.href,
      activity: activityId,
    });
    this.activityId = activityId;
  }

  async sendStatement(verb: string) {
    const statement = {
      verb: {
        id: `http://adlnet.gov/expapi/verbs/${verb}`,
        display: {
          'en-US': verb,
        },
      },
      object: {
        objectType: 'Activity',
        id: this.activityId,
      },
      context: this.getContext(this.activityId),
    };

    try {
      await new Promise((resolve, reject) => {
        this.xapi.sendStatements([statement], (err: any, response: any) => {
          if (err) {
            reject(err);
          } else {
            resolve(response);
          }
        });
      });
      console.log('Statement sent successfully!');
    } catch (error) {
      console.error('Error sending xAPI statement:', error);
    }
  }
  async initializeStatement(verb: string, id: string) {
    const statement = {
      verb: {
        id: `http://adlnet.gov/expapi/verbs/${verb}`,
        display: {
          'en-US': verb,
        },
      },
      object: {
        objectType: 'Activity',
        id: id,
      },
      context: this.getContext(id),
    };
    try {
      await new Promise((resolve, reject) => {
        this.xapi.sendStatements([statement], (err: any, response: any) => {
          if (err) {
            reject(err);
          } else {
            resolve(response);
          }
        });
      });
      console.log('Statement sent successfully!');
    } catch (error) {
      console.error('Error sending xAPI statement:', error);
    }
  }

  getContext(activityID: string) {
    return {
      contextActivities: {
        grouping: [
          {
            id: `${activityID}`,
          },
        ],
      },
    };
  }
  async sendQuizResult(
    verb: string,
    passed: boolean,
    score: number,
    maxScore: number,
    time: string
  ) {
    const statement = {
      verb: {
        id: `http://adlnet.gov/expapi/verbs/${verb}`,
        display: {
          'en-US': verb,
        },
      },
      object: {
        objectType: 'Activity',
        id: this.activityId,
      },
      context: this.getContext(this.activityId),
      result: {
        success: passed,
        completion: true,
        duration: time,
        score: {
          raw: score,
          max: maxScore,
          scaled: score / maxScore,
        },
      },
    };
    try {
      await new Promise((resolve, reject) => {
        this.xapi.sendStatements([statement], (err: any, response: any) => {
          if (err) {
            reject(err);
          } else {
            resolve(response);
          }
        });
      });
      console.log('Statement sent successfully!');
    } catch (error) {
      console.error('Error sending xAPI statement:', error);
    }
  }
  async sendLastKnownLocation(verb: string, currentTime: string) {
    const statement = {
      verb: {
        id: `http://adlnet.gov/expapi/verbs/${verb}`,
        display: {
          'en-US': verb,
        },
      },
      object: {
        objectType: 'Activity',
        id: this.activityId,
      },
      context: this.getContext(this.activityId),
      result: {
        duration: currentTime,
      },
    };
    try {
      await new Promise((resolve, reject) => {
        this.xapi.sendStatements([statement], (err: any, response: any) => {
          if (err) {
            reject(err);
          } else {
            resolve(response);
          }
        });
      });
      console.log('Statement sent successfully!');
    } catch (error) {
      console.error('Error sending xAPI statement:', error);
    }
  }
}

export default XAPIService;
